<template>
    <b-overlay
            :show="loading"
            rounded="sm"
    >
        <b-row>
            <b-col>
                <b-card
                        title="جزئیات نظر مشتری"
                >
                    <b-form
                            ref="opinionform"
                            @submit.prevent
                    >
                        <b-row>

                            <b-col
                                    class="mt-2"
                                    md="6"
                                    offset-md="3"
                            >
                                <b-row>


                                    <b-col md="12">
                                        <b-form-group
                                                label="نام"
                                                label-for="Name"
                                        >
                                            <b-form-input
                                                    id="Name"
                                                    v-model="Form.Name"
                                                    name="Name"
                                                    autocomplete="off"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <b-form-group
                                                label="توضیحات"
                                                label-for="Description"
                                        >
                                            <div class="form-label-group">
                                                <b-form-textarea
                                                    id="Description"
                                                    v-model="Form.Description"
                                                    name="Description"
                                                    rows="5"
                                                />
                                            </div>
                                        </b-form-group>

                                    </b-col>

                                    <b-col
                                        cols="12"
                                        class="mt-1"
                                    >
                                        <b-form-group>
                                            <b-form-checkbox
                                                v-model="Form.Visibility"
                                                name="Visibility"
                                                value="true"
                                                class="custom-control-success"
                                            >
                                                برای کاربر نمایش داده شود؟
                                            </b-form-checkbox>

                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    <b-col class="mt-1 mb-2 text-center">
                                        <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                type="submit"
                                                variant="primary"
                                                class="mr-1"
                                                @click="save"
                                        >
                                            ذخیره
                                        </b-button>
                                        <b-button
                                                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                variant="outline-secondary"
                                                @click="back"
                                        >
                                            بازگشت
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
export default {
    name: 'OpinionDetails',
    components: {},
    data() {
        return {
            Form: {
                Id: null,
                Name: null,
                Description: null,
                Visibility: true
            },
            loading: false,
        }
    },
    created() {
        if (this.$route.params.id) {
            this.Form.Id = this.$route.params.id
            this.get()
        }
    },
    methods: {
        save() {
            let url = this.$api.opinion.add
            if (this.$route.params.id) {
                url = this.$api.opinion.update
            }


            this.loading = true
            this.$http.post(
                url, this.Form,
            )
                .then(() => {
                    this.back()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        get() {
            this.loading = true
            this.$http.post(
                this.$api.opinion.get, {
                    Id: this.Form.Id,
                },
            )
                .then(res => {
                    this.loading = false
                    this.Form = res.data
                })
        },
    },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>